import {useTranslation} from 'react-i18next'
import {CREATIVE_TEMPLATES, type CreativeTemplateId} from '../../../common/constants/creativeAssetSpecs'

interface LayoutTemplatePickerProps {
  value: CreativeTemplateId
  onChange: (id: CreativeTemplateId) => void
}

const LayoutTemplatePicker = ({value, onChange}: LayoutTemplatePickerProps) => {
  const {t} = useTranslation()
  return (
    <div className="caa-templates">
      {CREATIVE_TEMPLATES.map((id) => (
        <button
          key={id}
          type="button"
          className={`caa-template${value === id ? ' is-active' : ''}`}
          onClick={() => onChange(id)}
        >
          <span className="caa-template-name">{t(`creativeAssets.templates.${id}.name`)}</span>
          <span className="caa-template-desc">{t(`creativeAssets.templates.${id}.desc`)}</span>
        </button>
      ))}
    </div>
  )
}

export default LayoutTemplatePicker
